import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FormField } from 'src/app/dashboard/admin/report/report';
import { GetCalculatesParamsService } from 'src/app/public-website/buyer/services/get-calculates-params.service';
import { ViewProductInfoHandlerService } from 'src/app/public-website/buyer/services/view-product-info-handler.service';
import { MapDialogComponent } from 'src/app/shared/components/map-dialog/map-dialog.component';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CurrencyExchangeService } from 'src/app/shared/services/currency-exchange.service';
import { GetBusinessProfileService } from 'src/app/shared/services/get-business-profile.service';
import { BaseEvent } from '../event/baseEvent';
import { EventTerms } from '../event/event.interface';
import { reservationProductObject, ReservationTicket } from './reservation.interface';
import { ProductCreationHelperService } from 'src/app/dashboard/seller/payment-pages/services/product-creation-helper.service';
import { ProductTypes } from 'src/app/shared/product/productTypes';

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss']
})
export class ReservationComponent extends BaseEvent implements AfterViewInit {
  parsedTickets: ReservationTicket[] = [];
  @Input() productObject: reservationProductObject;

  eventTermsObject:EventTerms;
  reservationImage;
  allTicketsSold:boolean;
  @ViewChild('inputVal') inputVal:ElementRef;
  ticketSelectionForm: FormGroup;
  private ticketForm: FormControl = new FormControl();
  private ticketSelected: ReservationTicket;
  url = window.location.href;
  ticketIndexSelected = 0;
  controls: { [key: string]: FormField } = {
    "ticketSelectd": {
      fieldName: 'Choose Booking Ticket',
      defaultValue: null,

    }
  }
  constructor(
    md: MatDialog,
    vpihs: ViewProductInfoHandlerService,
    auth: AuthService,
    getBusinessProfileService: GetBusinessProfileService,
    private Dialog: MatDialog,
    public exchangeService: CurrencyExchangeService,
    public getCalculatesParamsService: GetCalculatesParamsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private productCreationHelperService: ProductCreationHelperService
  ) {
    super(md, vpihs, auth, getBusinessProfileService, exchangeService, getCalculatesParamsService);
  }

  onTicketChange(event: any) {
    if (+event.target.value != this.ticketSelected.id) {
      this.ticketIndexSelected = this.parsedTickets.findIndex((ticket: ReservationTicket) => {
        return ticket.id == +event.target.value;
      })
      this.ticketSelected = this.parsedTickets[this.ticketIndexSelected];
      this.resetAfterProductChange();
    }
    this.inputVal.nativeElement.value='0';
  }
  async ngOnInit() {
    this.businessObject = this.productObject.Business;
    this.reservationImage = this.getNewProductValueByFieldName("image", "ReservationProductExtraInfo");
    this.eventTermsObject = { ...this.eventTermsObject,
      deliveryTerms: this.getNewProductValueByFieldName("deliveryTerms", "ReservationProductExtraInfo"),
      returnTerms: this.getNewProductValueByFieldName("returnTerms", "ReservationProductExtraInfo")
     };
    this.vpihs.currency = this.getNewProductValueByFieldName('currency','ProductExtraInfos');
    await this.initCurrencies();
    this.Tickets = this.productObject.ReservationTickets;



    this.parsedTickets = this.Tickets.map((ticket: ReservationTicket) => {
      let activeQuantity = ticket.quantity - ticket.pendingQuantity - ticket.paidQuantity

      if (activeQuantity) this.allTicketsSold = false;
      return {
        id: ticket.id,
        name: ticket.name,
        quantity: activeQuantity,
        maxQuantityPerSale: ticket.maxQuantityPerSale ? Math.min(ticket.maxQuantityPerSale, activeQuantity) : activeQuantity,
        price: ticket.price,
        quantityPerTicket: 1,
        expired: new Date() > new Date(ticket.expiry),
      };
    });
    this.ticketForm.setValue(this.parsedTickets[this.ticketIndexSelected].id);
    this.ticketSelected = this.parsedTickets[this.ticketIndexSelected];

    this.productCreationHelperService.checkParamsForOpriningCopyDialog(window.location.search, {
      serilizedUrl: this.url?.split("?")[0],
      product: {
        name: this.productObject.productName,
        type: ProductTypes.Reservation
      }
    })
  }

  openMap() {
   this.Dialog.open(MapDialogComponent, {
      height: "400px",
      width: "500px",
      data: {
        coordinates: this.getNewProductValueByFieldName("eventLocation", "ReservationProductExtraInfo")
      }
    });
  }
  proceedToPayment() {
    this.vpihs.setViewInfoObject({
      product: this.productObject,
      extras: this.extrasObject
    });
    this.vpihs.BusinessId = this.productObject.BusinessId;
    this.getCalculatesParamsService.setQuantity(this.quantity);
    this.getCalculatesParamsService.calculateInfos();
    this.vpihs.quantity = this.quantity;
    this.router.navigate(["buyerinfo"], { relativeTo: this.activatedRoute });
  }


}
